let copySource = {
    document: {
        title:'Comprar pontos/Dar pontos de presente'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'Comprar pontos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=pt-BR&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=pt-BR&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'Oferecer pontos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=pt-BR&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=pt-BR&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'Multiplique Pontos',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=pt-BR&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=pt-BR&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.com.br/default.mi'
        },
    },
    hero: {
        lang: 'landing-pt',
        headline: {
            lineOne: 'Pontos para seus caprichos. ',
            lineTwo: 'Compre agora, vá quando quiser.',
        },
        subHeadline : 'Quando a inspiração chegar, tenha os pontos para fazer\n acontecer. Seja um desvio gratificante ou uma experiência\n improvisada, há inúmeros lugares para ir e coisas para\n fazer. Compre ou dê pontos de presente agora.',
        alt:'Obtenha tudo com pontos e desfrute ao máximo da viagem. Reserve uma viagem que você sempre quis fazer. Passe mais noites fora. É o Ano de Mais – e é tudo possível com os pontos Marriott Bonvoy®.'
    },
    promo: {
        hero: {
            promoLang: 'promo-pt',
            headline: "Wonders of More",
            body:"Get closer to your next vacation with a 50% bonus on purchases of 2,000 or more points October 6–13.",
        }
    },
    ctas:{
        buy:{
            imgAlt:'Janela a partir do interior de um quarto de hotel com vista para a cidade.',
            header:'Comprar pontos',
            copy:'Desde adicionar uma diária à sua estadia, até o acesso VIP a um\n show esgotado, compre pontos agora mesmo para estar pronto\n para qualquer situação.',
            linkCopy:'COMPRAR PONTOS',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=pt-BR&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=pt-BR&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'Balcão do hotel com piscina com vista para o oceano',
            header:'Presentear com pontos',
            copy:'Presenteie os amigos e a família com pontos para que eles possam\n passear a qualquer hora e em qualquer lugar que quiserem.',
            linkCopy:'Presentear com pontos',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=pt-BR&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=pt-BR&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'Multiplique Pontos',
            copy:'Ganhou pontos em uma estadia recente? Agora você pode comprar até 4X mais com desconto para aproveitar melhor a sua próxima viagem.',
            linkCopy:'COMPRE PONTOS E ECONOMIZE',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=pt-BR&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=pt-BR&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'Tornar-se associado',
            link: 'https://www.marriott.com/pt-br/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'Obtenha acesso às Taxas de Associados, pontos para diárias gratuitas, e muito mais. Os novos associados podem adquirir pontos trinta (30) dias após a inscrição no programa Marriott Bonvoy.'
        }
    },
    footer:{
        copyrightOne: 'Este site é operado pela Points.com Inc. em nome da Marriott International, Inc. para a compra de Marriott Bonvoy Points de acordo com os ',
        copyrightLinkTC: '"https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-PT-BR.html',
        copyrightTwo:'Termos e Condições da Points.com Inc.',
        copyrightThree:'. A concessão e o uso de Marriott Bonvoy Points em conexão com uma transação de compra estão sujeitos à ',
        copyrightLinkTwo: 'https://www.marriott.com/about/privacy.mi',
        copyrightFour:'Política de Privacidade',
        copyrightFive:' e às ',
        copyrightLinkThree: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightSix:'Regras do Programa Marriott Bonvoy',
        copyrightSeven:'.',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: 'Português',
        tracking:{
            doNotSell:{
                copy:'Não venda meus dados pessoais',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'Preferências de rastreamento',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'Termos de utilização',
            href:'https://www.marriott.com.br/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'Termos e condições do programa',
            href:'https://www.marriott.com.br/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'Centro de privacidade',
            href:'https://www.marriott.com.br/sobre-marriott/declaracao-de-privacidade.mi'
        },
        accessibility:{
            copy:'Acessibilidade digital',
            href:'https://www.marriott.com.br/digital-accessibility.mi'
        },
        siteMap:{
            copy:'Mapa do site',
            href:'https://www.marriott.com.br/sitemap.mi'
        },
        help:{
            copy:'Ajuda',
            href:'https://www.marriott.com.br/help/default.mi'
        },
    }

}

export default copySource
